import { Navigate, useLocation } from 'react-router-dom';
import type { ReactElement, ReactNode } from 'react';
import { useAuth } from '../auth/useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }): ReactElement {
  const { isAuthenticated, availableRoutes } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Auth is handled by KeycloakAuthenticated at app level.
    // If this guard is reached, show an explicit session message instead of an endless loader.
    return <div style={{ padding: '2rem' }}>Session is not available. Please sign in again.</div>;
  }

  if (availableRoutes.length === 0) {
    return <div style={{ padding: '2rem' }}>You are authenticated but not authorized for any application route.</div>;
  }

  if (!availableRoutes.includes(location.pathname)) {
    return <Navigate to={availableRoutes[0]} replace />;
  }

  return <>{children}</>;
}
